import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import PropTypes from 'prop-types';
import ShareWidget from '../components/social/share-widget';
import { stringSubstitution } from '../components/contentful-views/util';
import { stringSubstitutionsPropType } from '../components/common-prop-types';
import { registerWidget } from '../components/contentful-views/sections';


const EmbeddableShareWidgetGlobalCSS = createGlobalStyle`
  // Pile on extra specificity to get the override here
  .contentPage > .content > .EmbeddableShareWidget {
    margin: 0;
  }
`

/**
 * Maps to the Share Widget content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/shareWidget/fields
 * @param {Object} props
 * @param {String} props.className
 * @param {String} props.position
 * @param {String} props.shareText
 * @param {String} props.shareUrl
 * @param {String} props.sites
 * @param {Object} props.stringSubstitutions
 */
const EmbeddableShareWidget = ({
  className,
  position,
  shareText,
  shareUrl,
  sites,
  stringSubstitutions,
}) => {
  // `position` refers to the side of the page we're on. The ShareWidget
  // should expand in the opposite direction.
  const expandDirection = position.match(/right$/) ? 'left' : 'right';
  return (
    <>
      <EmbeddableShareWidgetGlobalCSS/>
      <div className={`EmbeddableShareWidget fullWidth ${position} ${className}`}>
        <ShareWidget
          className='wrapper'
          appearance='round'
          sites={sites}
          expandDirection={expandDirection}
          url={shareUrl && stringSubstitution(shareUrl, stringSubstitutions)}
          text={shareText} />
      </div>
    </>
  );
};

EmbeddableShareWidget.propTypes = {
  className: PropTypes.string,
  sites: PropTypes.arrayOf(PropTypes.string).isRequired,
  position: PropTypes.oneOf(['left', 'right']),
  shareUrl: PropTypes.string,
  shareText: PropTypes.string,
  stringSubstitutions: stringSubstitutionsPropType,
};

EmbeddableShareWidget.defaultProps = {
  className: '',
  position: 'left',
  // `undefined`, as opposed to null, allows the next component to use its default
  shareUrl: undefined,
  shareText: undefined,
  stringSubstitutions: {},
};

const StyledEmbeddableShareWidget = styled(EmbeddableShareWidget)`
  // Create positioning context for child elements
  position: relative;

  // Push up into the margin between sections
  > .wrapper {
    position: absolute;
    top: -3em;
  }
  // Align to either the left or right of the page
  &.left > .wrapper {
    left: 1em;
  }

  &.right > .wrapper {
    right: 1em;
  }
`

registerWidget('shareWidget', StyledEmbeddableShareWidget);

export default StyledEmbeddableShareWidget;
